import { render, staticRenderFns } from "./InspectionAction.vue?vue&type=template&id=6c31893d&scoped=true"
import script from "./InspectionAction.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionAction.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionAction.vue?vue&type=style&index=0&id=6c31893d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c31893d",
  null
  
)

export default component.exports